var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.children.length
        ? _c(
            "v-menu",
            {
              attrs: {
                "offset-x": "",
                "nudge-left": "6",
                "content-class": "portal-locale-sub-menu"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "button",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "settings-link",
                                attrs: { type: "button" }
                              },
                              "button",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _vm.normalizedIcon
                              ? _c(
                                  "span",
                                  { staticClass: "settings-icon" },
                                  [
                                    _c("portal-icon", {
                                      attrs: {
                                        size: 17,
                                        name: _vm.normalizedIcon
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("span", { staticClass: "settings-label" }, [
                              _vm._v(_vm._s(_vm.label))
                            ]),
                            _c("portal-icon", {
                              staticClass: "ml-auto",
                              attrs: { name: "chevron-right", size: 15 }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                4068798689
              )
            },
            [
              _c(
                "div",
                { staticClass: "locale-options" },
                _vm._l(_vm.children, function(child) {
                  return _c(
                    "button",
                    {
                      key: child.code,
                      staticClass: "locale-option",
                      class: { "is-selected": _vm.isCurrent(child.code) },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("selected", child.code)
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(child.name))]),
                      _vm.isCurrent(child.code)
                        ? _c("portal-icon", {
                            attrs: { name: "check", size: 16 }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        : _c(
            "button",
            {
              staticClass: "settings-link",
              attrs: { type: "button" },
              on: { click: _vm.handleClick }
            },
            [
              _vm.normalizedIcon
                ? _c(
                    "span",
                    { staticClass: "settings-icon" },
                    [
                      _c("portal-icon", {
                        attrs: { size: 17, name: _vm.normalizedIcon }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("span", { staticClass: "settings-label" }, [
                _vm._v(_vm._s(_vm.label))
              ])
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }